"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const muiXTelemetryEvents = {
  licenseVerification: (context, payload) => ({
    eventName: 'licenseVerification',
    payload,
    context
  })
};
var _default = exports.default = muiXTelemetryEvents;